function createSlug(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}

// Función para procesar el nodo
function procesarNodo(nodo) {
  const attributeTitleSpan = nodo.querySelector(".snize-attribute");
  if (attributeTitleSpan && attributeTitleSpan.textContent.trim() !== "") {
    const textContent = attributeTitleSpan.textContent.trim();
    console.log(textContent);
    // Divide el texto usando el separador '-'
    const parts = textContent.split(",");

    if (parts.length > 0) {
      const coleccion = createSlug(parts[2].trim());
      const enlace = nodo.querySelector("a");

      if (enlace) {

        const nuevoHref =
          `/collections/${coleccion.toLowerCase()}` +
          enlace.getAttribute("href");
        enlace.href = nuevoHref;
        nodo.addEventListener("click", function (event) {
          event.stopImmediatePropagation();
          window.location.href = nuevoHref;
        });
      }
    }
  }
}

const targetNode = document.body;

// Configuración del observer, observando los cambios en los hijos y la adición de nuevos nodos
const config = { childList: true, subtree: true };

// Crea una instancia del MutationObserver
const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    // Recorre todos los nodos agregados en la mutación
    mutation.addedNodes.forEach((node) => {
      // Verifica si el nodo tiene la clase snize-product
      if (node.nodeType === 1 && node.classList.contains("snize-product")) {
        console.log("Nodo con la clase snize-product detectado:", node);
        // Procesa el nodo cuando aparezca
        procesarNodo(node);
      }
    });
  });
});

// Empieza a observar el DOM
observer.observe(targetNode, config);
